<template>
  <div id="init-home-container" class="d-flex background_color">
    <v-spacer></v-spacer>

    <v-main id="home-main" style="padding: 0 !important">
      <titlecard
        :title_text="'RENO - SPARKS REGIONAL INTELLIGENCE SERVICES'"
      ></titlecard>

      <v-container class="background_color black--text" id="home-container">
        <div id="big-card" class="d-flex justify-center align-center">
          <v-card
            id="home-content-area"
            class="mb-16 pt-4"
            color="white"
            elevation="4"
            outlined
          >
            <div class="ris-intro">
              <p>
                The Reno-Sparks Regional Intelligence Services (RIS) is a
                data-driven, analysis-based, and analytical intelligence-based
                collaborative approach to reducing crime in our region.
              </p>
              <p>
                The RIS focuses on emerging and existing technologies to enhance
                the emergency response and investigatory capabilities of our
                agencies, proactively identify threats, support operational
                decision-making, and strengthen our collective abilities to
                enhance the safety of our communities.
              </p>
              <div class="ris-transparency-resources">
                <h4>Please check out our transparency resources:</h4>
                <ul>
                  <li>
                    <a
                      href="https://transparency.flocksafety.com/reno-nv-pd"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Flock Safety Transparency Portal
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://dashboard.liveops.brincdrones.com/renopdnv"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      DFR Transparency Dashboard
                    </a>
                  </li>
                </ul>
              </div>
               <h4>Drone as First Responder Program:</h4>
               <ul>
                  <li>
                                        <a
                      href="https://dfr.renopd.com"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      DFR Information 
                    </a>
                    </li>
                    </ul>
            </div>

            <div id="contains-expansions-layout" class="d-flex justify-center">
              <v-expansion-panels id="all-panels" accordion>
                <ris-content-panel
                  panel-id="ris_vision"
                  title="Vision"
                  @onExpansionPanelClick="onExpansionPanelClick"
                >
                  <p>
                    To be a national leader and a model of excellence in
                    data-driven, analytical, and intelligence-led policing,
                    utilizing cutting-edge technology and the power of a
                    multi-agency collaborative approach to create safer
                    communities.
                  </p>
                </ris-content-panel>

                <ris-content-panel
                  panel-id="ris_administration"
                  title="Administration"
                  @onExpansionPanelClick="onExpansionPanelClick"
                >
                  <p>
                    A Lieutenant supervises the RIS, which comprises several
                    subordinate units, each overseen by a Sergeant.
                  </p>

                  <h5>Real Time Information Center</h5>
                  <p>
                    The Real Time Information Center (RTIC) is responsible for
                    actively monitoring and disseminating information gained from
                    surveillance technologies and available databases to support
                    active incidents occurring in our area.
                  </p>
                  <p>
                    RTIC may be utilized, time permitting, to assist with
                    past-tense investigations when assistance is needed, to
                    access and preserve surveillance data, or to support other
                    available resources.
                  </p>

                  <h5>Crime Gun Intelligence Center</h5>
                  <p>
                    The Gun Crime Intelligence Center (CGIC) is responsible for
                    active investigations into gun crime-related incidents. CGIC
                    not only focuses on offenders but also on the weapons used in
                    crime.
                  </p>
                  <p>
                    Through intelligence-based practices and evidence-based
                    linking, CGIC Detectives and assigned personnel take a
                    proactive approach to reduce gun violence in our communities.
                  </p>
                  <p>
                    Additionally, CGIC partners with additional units within our
                    agencies, such as Detectives, the Regional Gang Unit, the
                    Regional Crime Suppression Unit, and Federal partners, to
                    provide intelligence and investigatory support for those
                    incidents within their purview related to gun violence.
                  </p>

                  <h5>Crime Analysis Unit</h5>
                  <p>
                    The Crime Analysis Unit (CAU) is responsible for collecting,
                    analyzing, and interpreting crime data to assist Officers and
                    Detectives in their ongoing criminal investigations, as well
                    as for identifying trends and potential focus areas to
                    support crime prevention.
                  </p>
                  <p>
                    The CAU also provides data and interpretation to assist
                    Command and Executive level Officers with the information
                    needed to make informed decisions.
                  </p>
                </ris-content-panel>

                <ris-content-panel
                  panel-id="ris_coordination"
                  title="Coordination"
                  @onExpansionPanelClick="onExpansionPanelClick"
                >
                  <p>
                    Both RTIC and CAU are supporting assets designed to
                    complement existing units and Sections in their
                    investigations. Employees are expected to confirm the RTIC
                    and CAU information and data presented independently.
                  </p>
                  <p>
                    Although deemed reliable, RTIC and CAU employees cannot
                    independently establish probable cause for arrest due to the
                    nature of the investigative tools available to them.
                  </p>
                  <p>
                    CGIC Detectives are expected to take a proactive approach to
                    their mission and actively investigate criminal behavior with
                    a gun nexus. CGIC Detectives are expected to manage a case
                    load assigned to them by the supervising Sergeant.
                  </p>
                  <p>
                    The CGIC Sergeant will coordinate with other units within
                    both the Reno and Sparks Police Departments to ensure the
                    proper units and resources are engaged for each incident.
                  </p>
                  <p>
                    In incidents where a unit other than CGIC takes the lead on
                    a criminal investigation, CGIC Detectives will remain a part
                    of the investigation in an intelligence and coordination
                    role.
                  </p>
                  <p>
                    As part of the RIS, both Reno and Sparks employees will be
                    cross trained in all available technologies to ensure
                    interoperability and support both agencies during critical
                    incidents or pre-planned operations.
                  </p>
                  <p>
                    RIS leadership will also coordinate with other department
                    units and City officials, such as IT, Innovation and
                    Technology, Maintenance and Operations, Traffic Engineers,
                    and various vendors and contracted employees.
                  </p>
                </ris-content-panel>

                <ris-content-panel
                  panel-id="ris_org_chart"
                  title="Organizational Chart"
                  @onExpansionPanelClick="onExpansionPanelClick"
                >
                  <div class="org-chart-container">
                    <img
                      src="../images/org.png"
                      alt="RIS organizational chart"
                      class="org-chart-img"
                    />
                  </div>
                </ris-content-panel>
              </v-expansion-panels>
            </div>
          </v-card>
        </div>
      </v-container>
    </v-main>

    <v-spacer></v-spacer>
    <v-btn
      id="fabup"
      ref="fabup"
      @click.prevent="fabup"
      title="Top of page"
      class="fabup"
      elevation="2"
      fab
      color="yellow accent-2"
    >
      <v-icon color="black" dark x-large> $chevup </v-icon>
    </v-btn>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

@media (min-width: 0px) {
  .fabup {
    position: fixed;
    left: 85%;
    top: 90%;
    z-index: 500;
  }

  #all-panels {
    width: 90%;
  }

  .ris-intro {
    color: black;
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 1.55;
    margin: 0 auto 18px;
    padding: 4px 22px 12px;
    width: 90%;
  }

  .ris-intro p {
    margin-bottom: 12px;
  }

  .ris-transparency-resources {
    font-size: 1rem;
    line-height: 1.4;
    padding: 0 12px;
  }

  .ris-transparency-resources h4 {
    color: #283a44;
    font-size: 1.05rem;
    font-weight: 700;
    margin: 6px 0;
  }

  .ris-transparency-resources ul {
    margin: 0;
    padding-left: 22px;
  }

  .ris-transparency-resources li {
    margin: 4px 0;
  }

  .v-main {
    padding: 0 !important;
  }

  .theme--light.v-expansion-panels .v-expansion-panel {
    color: white;
  }
}

@media (min-width: 768px) {
  .fabup {
    position: fixed;
    left: 95%;
    top: 90%;
  }

  #init-home-container {
    width: 100%;
  }

  #home-container {
    width: 100vw;
    height: auto;
    position: relative;
    top: 0px;
  }

  #home-content-area {
    width: 100%;
    max-width: 85%;
    height: auto;
    background-color: white;
  }

  #all-panels {
    width: 95%;
  }

  .ris-intro {
    width: 95%;
  }

  .ris-transparency-resources {
    font-size: 1.08rem;
  }

  .ris-transparency-resources h4 {
    font-size: 1.15rem;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
const titlecard = () => import("./titlecard.vue");
const RisContentPanel = () => import("./ris_content_panel.vue");

export default {
  name: "Home",
  components: {
    titlecard,
    RisContentPanel,
  },
  mixins: [bus_common],
  methods: {
    fabup(event) {
      const bdy = document.getElementsByClassName("bodyback")[0];
      bdy.scroll({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
      document.getElementById("fabup").blur();
    },
    onExpansionPanelClick(event) {
      var targetID = event.currentTarget.id;
      if (
        event.currentTarget.classList.contains(
          "v-expansion-panel-header--active"
        )
      ) {
        console.log("Panel is closing/now closed.");
      } else {
        console.log("Panel is opening/now open.");
        setTimeout(
          function () {
            console.log(targetID);
            const element = document.getElementById(targetID);
            if (element) {
              element.scrollIntoView({ behavior: "smooth" });
            }
          },
          500,
          targetID
        );
      }
    },
    init(self) {
      this.show_loader(false);
    },
  },
  mounted() {
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
